import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./locales/en/common.json";
import ru from "./locales/ru/common.json";
import uz from "./locales/uz/common.json";

const STORED_LANG_KEY = "tibbiy-korik-lang";
const stored = typeof localStorage !== "undefined" ? localStorage.getItem(STORED_LANG_KEY) : null;

i18n.use(initReactI18next).init({
  resources: {
    en: { common: en },
    ru: { common: ru },
    uz: { common: uz },
  },
  lng: stored ?? "uz",
  fallbackLng: "en",
  defaultNS: "common",
  interpolation: { escapeValue: false },
});

i18n.on("languageChanged", (lng) => {
  if (typeof localStorage !== "undefined") {
    localStorage.setItem(STORED_LANG_KEY, lng);
  }
});

export default i18n;
